import { render, staticRenderFns } from "./documentDialog.vue?vue&type=template&id=c6283618&scoped=true"
import script from "./documentDialog.vue?vue&type=script&lang=js"
export * from "./documentDialog.vue?vue&type=script&lang=js"
import style0 from "./documentDialog.vue?vue&type=style&index=0&id=c6283618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6283618",
  null
  
)

export default component.exports